const triggerCustomerPanelWebhook = async (wingsId) => {
    const myHeaders = new Headers();
    // myHeaders.append("Authorization", ""); // No auth token needed

    const formdata = new FormData();
    formdata.append("WingsId", wingsId);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    try {
        const response = await fetch(
            `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/insert-into-customerpanelcases`,
            requestOptions
        );
        const result = await response.text();
        console.log("Customer Panel Webhook Result:", result);
        return result;
    } catch (error) {
        console.error("Customer Panel Webhook Error:", error);
        throw error;
    }
};

export default triggerCustomerPanelWebhook;
